var DialogMixin = {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    showAlert(v) {
      //this.dialog = true;
      let setDialog = {
        message: '',
      };
      if (v === null || typeof v !== 'object') {
        setDialog.message = v;
      } else {
        setDialog = v;
      }
      setDialog.dialog = true;
      return window.app.$children[0].showAlert(setDialog);
    },
  },
};

export { DialogMixin };
